import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Simplified initialization service that tracks the app's initialization state
 * but delegates the actual initialization to existing components.
 */
@Injectable({
    providedIn: 'root'
})

export class InitializationService {

    // Status tracking
    initializationStatusSubject = new BehaviorSubject<'idle' | 'initializing' | 'completed' | 'error'>('idle');
    readonly initializationStatus$ = this.initializationStatusSubject.asObservable();

    // User info
    userUID: string | null = null;

    constructor() { }

    /**
     * Set the initialization status
     * @param status The new status
     */
    setStatus(status: 'idle' | 'initializing' | 'completed' | 'error'): void {
        this.initializationStatusSubject.next(status);
    }

    /**
     * Check if the app is initialized
     */
    isInitialized(): boolean {
        return this.initializationStatusSubject.getValue() === 'completed';
    }

    /**
     * Set the user ID
     * @param userId The user ID
     */
    setUserId(userId: string): void {
        this.userUID = userId;
    }

    /**
     * Reset initialization state
     */
    resetInitialization(): void {
        this.initializationStatusSubject.next('idle');
    }
}